<template>
<!--  <NavBar></NavBar>-->
  <router-view/>
</template>

<script>
// import NavBar from 'components/HelloWorld'
import $ from 'jquery'

export default {
  name: 'app',
  components: {
    // NavBar,
  },
  mounted() {
    $(document).on("click", ".cerrarModal", function () {
      $(".dropdown-content").fadeOut();
      $(".cerrarModal").attr("class", "")
    })
  }
}
</script>
<style>
@import "static/css/style.css";
</style>
